import { combineReducers } from 'redux'
import App from './app/reducer'
import Auth from './auth/reducer'
import User from './user/reducer'
import Home from './home/reducer'
import Wallets from './wallets/reducer'
import Stake from './stake/reducer'
import Transactions from './transactions/reducer'
import File from './file/reducer'
import NetWorks from './networks/reducer'
import Package from './package/reducer'
import Invest from './invest/reducer'
import Exchange from './exchange/reducer'

export default combineReducers({
  app: App,
  auth: Auth,
  home: Home,
  user: User,
  wallets: Wallets,
  stake: Stake,
  transactions: Transactions,
  networks: NetWorks,
  file: File,
  package: Package,
  invest: Invest,
  exchange: Exchange,
})
